<template>
  <div class="m-card">
    <div class="header">WC</div>
    <div class="content">
      <div class="item" >
        <!-- <div style="position: relative">
          <img src="@/assets/images/hino element/chart_mathlab.gif" alt="" />
          <h2
            style="font-weight: bold; z-index: 2; position: absolute; top: 0px"
          >
            0{{ i+1 }}
          </h2>
        </div> -->
        <div style="position: relative" id="gauge_cpf" v-if="max!=0">
          <h1
            style="
              font-weight: bold;
              position: absolute;
              top: 60%;
              left: 50%;
              transform: translate(-50%, -50%);
            "
          >
            {{ dataWC }}
            <!-- <sup style="font-weight: 100">°C</sup> -->
          </h1>
          <vue-gauge
            :refid="'type-unique-id2'"
            :options="{
              hasNeedle: true,
              outerNeedle: true,
              needleStartValue: 0,
              needleColor: 'red',
              arcColors: ['#66BB6A', '#E0E0E0'],
              needleValue: [maxCom],
              arcDelimiters: [data4_20],
              rangeLabel: ['0', '20'],
              needleUpdateSpeed: 1,
            }"
          ></vue-gauge>
        </div>
        <div class="box_3">
          <div class="max">max</div>
          <div class="temp">{{ max }} in.WC
            <!-- <sup>°C</sup> -->
            </div>
          <div class="min">min</div>
          <div class="temp">{{ min }} in.WC
            <!-- <sup>°C</sup> -->
          </div>
          <div
            style="
              grid-row: 3/4;
              grid-column: 1/3;
              display: flex;
              flex-direction: column;
              align-items: flex-end;
            "
          >
            <div class="date">Date : {{ time_stamp.split(" ")[0] }}</div>
            <div class="date">time : {{ time_stamp.split(" ")[1] }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueGauge from "vue-gauge";

export default {
  props: {
    dataWC: String,
    max: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    time_stamp: String,
  },
  components: { VueGauge },

  data() {
    return {
      today: this.$moment().format("YYYY-MM-DD"),
      time: this.$moment().format("hh:mm:ss"),
      num:1,
    };
  },
  mounted() {
    this.selectData();
  },
  methods: {
    selectData() {},
  },
  computed:{
    data4_20:{
      get(){
        console.log("data4_20",this.dataWC);
        if (Number(this.dataWC)<=0) {
          return 0.001
        }else if(Number(this.dataWC)>=20) {
          return 19.9999*100/20
        }
        // const content = document.getElementById("gauge_cpf").innerHTML;
        // document.getElementById("gauge_cpf").innerHTML = content;
        return Number(this.dataWC)*100/20
        // this.num += 10
        // return this.num
      },
    },
    maxCom(){
      return Number(this.max)*100/20
    }
  },
};
</script>

<style lang="scss" scoped>
.m-card {
  color: var(--text-color-2);
}
.content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
img {
  width: 100%;
  z-index: 1;
  margin-top: 1rem;
}
.item {
  // display: grid;
  // grid: max-content/ auto auto;
  display: flex;
  flex-wrap: wrap;
    justify-content: space-around;
  align-items: center;
  justify-items: center;
  gap: 5px;
}
.box_3 {
  display: grid;
  grid: auto auto auto auto/min-content auto;
  gap: 5px;
}
.min {
  //   font-weight: 800;
  //   margin-bottom: 0.5rem;
  color: #f707ff;
}
.max {
  //   font-weight: 800;
  //   margin-bottom: 0.5rem;
  color: #8f07ff;
}
.temp {
  font-weight: 700;
  color: var(--text-color);
}
.date {
  font-size: 0.7rem;
}
.header {
  text-align: center;
  font-size: 2.25rem;
  font-weight: bold;
}
</style>